import React from 'react';
import { withGoogleMap, GoogleMap, Marker, Circle } from 'react-google-maps';
import { Box } from '@material-ui/core';
import { useSelector } from 'react-redux';
import useStyles from './styles';

function MapsModal({ coordinates }) {
  const classes = useStyles();
  const { currentLocation } = useSelector(state => state.adresses);

  const MapWithAMarker = React.useCallback(
    withGoogleMap(() => (
      <GoogleMap
        defaultOptions={{
          disableDefaultUI: true,
          mapTypeControl: false,
          gestureHandling: 'greedy',
          scrollwheel: false,
          streetViewControl: false,
          draggable: false,
        }}
        defaultZoom={18}
        defaultCenter={coordinates}
      >
        <Circle
          options={{
            center: currentLocation,
            fillColor: '#ADD8E6',
            strokeWeight: 1,
            radius: 14,
            strokeOpacity: 0.5,
            strokeColor: '#ADD8E6',
          }}
        />
        <Circle
          options={{
            center: currentLocation,
            fillColor: '#6495ED',
            strokeWeight: 0,
            radius: 10,
            strokeOpacity: 0,
            strokeColor: '#6495ED',
          }}
        />
        <Circle
          options={{
            center: currentLocation,
            fillColor: '#0000FF',
            strokeWeight: 2,
            radius: 5,
            strokeColor: '#FFF',
          }}
        />
        <Marker position={coordinates} />
      </GoogleMap>
    )),
    [coordinates]
  );

  return (
    <Box className={classes.root}>
      <MapWithAMarker
        containerElement={<div style={{ height: '150px' }} />}
        mapElement={<div style={{ height: `100%` }} />}
      />
    </Box>
  );
}

export default MapsModal;
